<template>
  <main class="container-1 terrain-form-preview">
    <div class="container-header"><Breadcrumb :links="routesBread" /><h2>Vista previa de plantilla</h2></div>
    <div class="container-body"><TerrainFormRenderer :definition="definition" :answers.sync="previewAnswers" mode="preview" sanitize-hidden-answers /></div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb.vue';
import TerrainFormRenderer from '@/components/terrain/form/TerrainFormRenderer.vue';

export default {
  name: 'TerrainFormPreview',
  components: { Breadcrumb, TerrainFormRenderer },
  computed: {
    ...mapGetters('terrain', ['builderDraft']),
    definition() { return this.builderDraft || { schemaVersion: 1, sections: [], reviewSections: [] }; },
    routesBread() { return [{ name: 'Terreno' }, { name: 'Plantillas' }, { name: 'Vista previa' }]; },
  },
  data() { return { previewAnswers: [] }; },
};
</script>

<style scoped lang="scss">
.terrain-form-preview .container-body { margin: 0 auto; max-width: 800px; width: 95%; }
</style>
